import React, { createElement, forwardRef, useContext } from 'react';
import { ContainerContext } from './context/index.js';
const excludeProperties = ['acceptedTypes', 'exclusive', 'repeated'];
function prepareProperties(properties) {
    return Object.keys(properties)
        .filter(key => !excludeProperties.includes(key))
        .reduce((props, key) => (props[key] = properties[key], props), {});
}
const Container = forwardRef(function Container(props, ref) {
    const context = useContext(ContainerContext);
    if (context) {
        const { children, ...otherProps } = props;
        return createElement(context.container, { ...otherProps }, children);
    }
    const { children, className = '', tag: Tag = 'div', ...otherProps } = prepareProperties(props);
    return (React.createElement(Tag, { className: `c-container ${className}`, ...otherProps, ref: ref }, children));
});
export { Container, };
//# sourceMappingURL=container.js.map